import dayjs from 'dayjs';

export function getStartDate(
  isValidYear: boolean,
  isValidMonth: boolean,
  year: string | undefined,
  month: string | undefined,
) {
  if ((!isValidYear && !isValidMonth) || !year || !month) {
    return dayjs().startOf('month').format('YYYY-MM-DD');
  }
  return dayjs(`${year}-${month}-01`).startOf('month').format('YYYY-MM-DD');
}

export function getIsValidYear(year: string | undefined): boolean {
  return !!year && !Number.isNaN(year) && year.length === 4;
}

export function getIsValidMonth(month: string | undefined): boolean {
  return !!month && !Number.isNaN(month) && /^[1-9]$|^1[0-2]$/.test(month);
}
